import { render, staticRenderFns } from "./PublishEventModal.vue?vue&type=template&id=3df28a02&scoped=true&"
import script from "./PublishEventModal.vue?vue&type=script&lang=js&"
export * from "./PublishEventModal.vue?vue&type=script&lang=js&"
import style0 from "./PublishEventModal.vue?vue&type=style&index=0&id=3df28a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df28a02",
  null
  
)

export default component.exports